const actions = {
	GO_REDIRECT_BY_UNIQID: 'GO_REDIRECT_BY_UNIQID',
	redirect: ({ uniqId }) => ({
		type: actions.GO_REDIRECT_BY_UNIQID,
		uniqId,
	}),
};

export default actions;
